var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentQuote)?_c('CategoryQuoteCard',{attrs:{"quote":_vm.currentQuote}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }